import React from 'react';

interface BackButtonProps {
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent) => void;
  disabled?: boolean;

  size?: 'small' | 'medium';
}

const BackButton: React.FC<BackButtonProps> = ({
  children,
  onClick,
  disabled = false,

  size = 'medium',
}) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onClick?.(e);
  };

  const buttonClass = size === 'small' ? 'c-btn-back -small' : 'c-btn-back';

  return (
    <div className={buttonClass}>
      <button
        type='button'
        onClick={onClick ? handleClick : undefined}
        disabled={disabled}
      >
        {children}
      </button>
    </div>
  );
};

export default BackButton;
